import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { NeedsPermissionDirective } from "./needsPermission.directive";

@NgModule({
    declarations: [NeedsPermissionDirective],
    imports: [CommonModule],
    exports: [NeedsPermissionDirective]
})
export class NeedsPermissionModule { }